














































import { Component } from 'vue-property-decorator';
import RouterHelper from '@shared/helpers/router.helper';
import { webinarLink } from '@shared/data';
import CBtn from '@web/components/CBtn.vue';
import HomeSection from '../Home/Section.abstract';

const routerHelper = new RouterHelper();

@Component({
  components: {
    CBtn,
  },
})
export default class HomeTop extends HomeSection {
  headersAppearence = true;

  headersRefs = {
    header: 'header',
    content: 'content',
  };

  signup() {
    this.$router.push(routerHelper.signup().getRoute());
  }

  get webinarLink(): string {
    return webinarLink;
  }
}
